
import { Component, Vue, Ref } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { PermissionModule } from '@/store/modules/permission'
import SidebarItem from './sidebarItem.vue'
import SidebarLogo from './sidebarLogo.vue'
import variables from '@/styles/settings/variables.scss'
const SCROLL_STORAGE_KEY = 'sidebar_scroll_position'

@Component({
    name: 'Sidebar',
    components: {
        SidebarItem,
        SidebarLogo
    }
})
export default class Sidebar extends Vue {
    @Ref('scrollRef') private scrollEl!: HTMLElement
    private savedScrollTop = 0
    private isRestoring = false

    mounted() {
        this.savedScrollTop = Number(localStorage.getItem(SCROLL_STORAGE_KEY) || 0)
        this.$nextTick(() => {
            this.restoreScrollPosition()
        })
    }

    private restoreScrollPosition() {
        if (this.scrollEl && this.savedScrollTop > 0) {
            this.isRestoring = true
            this.scrollEl.scrollTop = this.savedScrollTop
            setTimeout(() => {
                this.isRestoring = false
            }, 100)
        }
    }

    public onScroll() {
        if (this.isRestoring) return
        if (this.scrollEl) {
            this.savedScrollTop = this.scrollEl.scrollTop
            localStorage.setItem(SCROLL_STORAGE_KEY, String(this.savedScrollTop))
        }
    }
    
    get sidebar() {
        return AppModule.sidebar
    }

    get routes() {
        return PermissionModule.routes
    }

    get variables() {
        return variables
    }

    get activeMenu() {
        const route = this.$route
        const { meta, path } = route
        // if set path, the sidebar will highlight the path you set
        if (meta.activeMenu) {
            return meta.activeMenu
        }
        return path
    }

    get isCollapse() {
        return !this.sidebar.opened
    }

    get defaultOpeneds() {
        const activePath = this.$route.path
        const pathSegments = activePath.split('/').filter(Boolean)
        const parentPaths: string[] = []
        let currentPath = ''
        for (let i = 0; i < pathSegments.length - 1; i++) {
            currentPath += '/' + pathSegments[i]
            parentPaths.push(currentPath)
        }
        return parentPaths
    }
}
